interface TagChip {
  slug: string;
  label: string;
}

interface ActiveFiltersBarProps {
  cityLabel: string | null;
  tagChips: TagChip[];
  onClearCity: () => void;
  onRemoveTag: (slug: string) => void;
  onClearAll: () => void;
  resultsCount: number;
}

function PinIcon() {
  return (
    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
      <circle cx="12" cy="10" r="3" />
    </svg>
  );
}

function TagIcon() {
  return (
    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M20.59 13.41 13.42 20.58a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z" />
      <line x1="7" y1="7" x2="7.01" y2="7" />
    </svg>
  );
}

export function ActiveFiltersBar({
  cityLabel,
  tagChips,
  onClearCity,
  onRemoveTag,
  onClearAll,
  resultsCount,
}: ActiveFiltersBarProps) {
  const totalChips = (cityLabel ? 1 : 0) + tagChips.length;
  if (totalChips === 0) return null;

  return (
    <div className="active-filters" role="region" aria-label="Filtros ativos">
      <div className="active-filters__summary">
        <strong>{resultsCount}</strong>&nbsp;
        {resultsCount === 1 ? 'experiência encontrada' : 'experiências encontradas'}
      </div>
      <div className="active-filters__chips">
        {cityLabel && (
          <button
            type="button"
            className="active-filters__chip"
            onClick={onClearCity}
            aria-label={`Remover filtro de cidade ${cityLabel}`}
          >
            <PinIcon />
            {cityLabel}
            <span className="active-filters__x" aria-hidden="true">×</span>
          </button>
        )}
        {tagChips.map((chip) => (
          <button
            key={chip.slug}
            type="button"
            className="active-filters__chip"
            onClick={() => onRemoveTag(chip.slug)}
            aria-label={`Remover tag ${chip.label}`}
          >
            <TagIcon />
            {chip.label}
            <span className="active-filters__x" aria-hidden="true">×</span>
          </button>
        ))}
      </div>
      {totalChips > 1 && (
        <button type="button" className="active-filters__clear" onClick={onClearAll}>
          Limpar tudo
        </button>
      )}
    </div>
  );
}
